var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Policies" },
    [
      _vm.policies && _vm.policies.length
        ? [
            _c(
              "div",
              { staticClass: "Policies--wrapper" },
              _vm._l(_vm.policies, function(policy, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "Policies--wrapper-content" },
                  [
                    _c(
                      "h3",
                      { staticClass: "Policies--wrapper-content-title" },
                      [_vm._v(_vm._s(policy.title))]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "Policies--wrapper-content-data",
                      domProps: { innerHTML: _vm._s(policy.content) }
                    })
                  ]
                )
              }),
              0
            )
          ]
        : [_vm._m(0)]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "not-found" }, [
      _c("img", {
        attrs: {
          src: require("../../../../assets/img/empty-policies.png"),
          alt: "NoPolicies"
        }
      }),
      _vm._v(" "),
      _c("h3", [_vm._v("Sorry, no policies")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1fb29a68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fb29a68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/pages/Activities/Policies.vue
// module id = null
// module chunks = 